import "./index.css";
const Newloader = () => {
  return <div className="newloader"></div>;
};

export default Newloader;
